import { useHuddle01 } from '../HuddleContext';

export default useHuddle01;
